/* eslint-disable import/prefer-default-export */
import { UseQueryOptions } from "@tanstack/react-query";
import { getTrackingReferences } from "api/services/shipment";
import { useCustomQuery } from "hooks/useCustomQuery";
import { shipmentQueryKeys } from "./shipmentQueryKeys";

export const useGetTrackingReferences = (shipmentId: string, options?: UseQueryOptions): any =>
  useCustomQuery({
    queryKey: shipmentQueryKeys.shipmentTrackingReferences(shipmentId),
    queryFn: () => getTrackingReferences(shipmentId).then((res) => res.data),
    ...options,
  });
